<template>
  <div class="step-indicator d--f jc--c mb-30px">
    <div
      v-for="(_, index) in steps"
      :key="index"
      class="step-dot d--f jc--c ai--c"
      :class="{
        'step-active': store.currentStep === index,
        'step-completed': store.currentStep > index,
      }"
      @click="goToStep(index)"
    >
      <span v-if="store.currentStep > index" class="step-check">✓</span>
      <span v-else>{{ index + 1 }}</span>
    </div>
  </div>
</template>

<script setup>
import { useReportFormStore } from "@/stores/reportFormStore";

defineProps({
  steps: {
    type: Array,
    required: true,
  },
});

const store = useReportFormStore();

const goToStep = (step) => {
  // Only allow going to completed steps or the next available step
  if (step < store.currentStep || step === store.currentStep + 1) {
    store.setStep(step);
  }
};
</script>

<style lang="scss" scoped>
.step-indicator {
  display: flex;
  gap: 10px;
}

.step-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: $color-grey-12;
  color: $color-grey-6;
  font-weight: 500;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-active {
  background-color: $color-primary;
  color: white;
}

.step-completed {
  background-color: $color-green;
  color: white;
}

.step-check {
  font-size: 14px;
}
</style>
